import { ComponentChildren, h } from "preact";
import "./menu.scss";
import { IconSvg } from "./iconsvg";

export function Menu(props: { children: ComponentChildren }) {
    return (
        <div className="component4-menu">
            {
                props.children
            }
        </div>
    );
}

export function MenuItem(props: { label: string, icon?: string, disabled?: boolean, onClick?: () => void }) {
    return (
        <div className={"component4-menuitem" + (props.disabled ? " disabled" : "")} onClick={props.disabled ? undefined : props.onClick}>
            {
                props.icon && IconSvg(props.icon)
            }
            {
                props.label
            }
        </div>
    );
}
